module.exports = __webpack_public_path__ + "img/for-xperia-only.37ae7db3.png";